import { render, staticRenderFns } from "./Routing.vue?vue&type=template&id=5e068b45"
import script from "./Routing.vue?vue&type=script&lang=js"
export * from "./Routing.vue?vue&type=script&lang=js"
import style0 from "./Routing.vue?vue&type=style&index=0&id=5e068b45&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports